import { useState } from 'react';
import InputField from '../../../../../components/molecules/InputField';
import InputFieldSelect from '../../../../../components/molecules/InputField/InputFieldSelect';
import { API_METHODS, RESPONSE_TYPES } from '../../../../../consts/builder';
import InputFieldSwitch from '../../../../../components/molecules/InputField/InputFieldSwitch';

const NodeApiConfig = ({ config }) => {
    const [selectedForm, setSelectedForm] = useState(0);
    return (
        <div>
            <div className='p-5'>
                <h5 className='fs-8'>Method</h5>
                <InputFieldSelect
                    defaultValue={config?.method}
                    className='form-select-xs input-group-prepend w-100px'
                    config={{
                        name: 'method',
                        label: '...',
                        options: API_METHODS,
                    }}
                />
                <h5 className='fs-8 mt-3'>Request URL</h5>
                <InputField
                    defaultValue={config.url}
                    config={{
                        name: 'value',
                        className: 'form-control-xs',
                    }}
                />
                <h5 className='fs-8 mt-3'>Run in Background?</h5>
                <InputFieldSwitch
                    defaultValue={config?.async}
                    config={{ name: 'async', hideLabel: true }}
                />
                <h5 className='fs-8 mt-3'>Response Type?</h5>
                <InputFieldSelect
                    defaultValue={config?.response_type}
                    className='form-select-xs input-group-prepend w-150px'
                    config={{
                        name: 'response_type',
                        options: RESPONSE_TYPES,
                    }}
                />
                {config?.response_type === 'file' && (
                    <>
                        <h5 className='fs-8 mt-3'>Vendor</h5>
                        <InputField
                            defaultValue={config.vendor}
                            config={{
                                name: 'vendor',
                                className: 'form-control-xs',
                            }}
                        />
                    </>
                )}
            </div>
            {[
                { value: 'body', label: 'Body', icon: 'bi-file-ruled' },
                { value: 'headers', label: 'Request Headers', icon: 'bi-journal-code' },
                { value: 'params', label: 'Params', icon: 'bi-question' },
                { value: 'ssl', label: 'SSL', icon: 'bi-shield-check' },
            ].map((type, formIndex) => {
                return (
                    <div className='panel__section p-5'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <i
                                    className={`bi ${type.icon} me-1 ${
                                        selectedForm === formIndex ? 'text-info' : ''
                                    }`}></i>
                                <h5
                                    onClick={() =>
                                        setSelectedForm(selectedForm === formIndex ? -1 : formIndex)
                                    }
                                    className='fs-8 p-0 m-0 cursor-pointer'>
                                    {type.label}
                                </h5>
                            </div>
                            <div>
                                <span
                                    className='cursor-pointer ms-2'
                                    onClick={() =>
                                        setSelectedForm(selectedForm === formIndex ? -1 : formIndex)
                                    }>
                                    <i
                                        className={`bi bi-chevron-${
                                            selectedForm === formIndex ? 'up' : 'down'
                                        }`}></i>
                                </span>
                            </div>
                        </div>
                        {selectedForm === formIndex && config?.[type.value] && (
                            <div
                                className='my-3'
                                key={type.value}>
                                <div className='d-flex justify-content-between'>
                                    {(!config?.[type.value] ||
                                        config?.[type.value]?.length === 0) && (
                                        <span className='cursor-pointer ms-1'>
                                            <i className='bi bi-plus-circle-fill'></i>
                                        </span>
                                    )}
                                </div>
                                {Object.entries(config?.[type.value])?.map(
                                    ([key, value], index) => {
                                        return (
                                            <div
                                                className='d-flex align-items-center mb-5'
                                                key={`${type.value}_${index}`}>
                                                <InputField
                                                    defaultValue={key}
                                                    config={{
                                                        name: 'key',
                                                        placeholder: 'Key',
                                                        className: 'form-control-xs w-100px me-2',
                                                    }}
                                                />
                                                <div className='flex-fill'>
                                                    <InputField
                                                        defaultValue={value}
                                                        config={{
                                                            name: 'value',
                                                            placeholder: 'Value',
                                                            className: 'form-control-xs me-2',
                                                        }}
                                                    />
                                                </div>
                                                <div className='ms-2'>
                                                    <span className='cursor-pointer ms-1'>
                                                        <i className='bi bi-plus-circle-fill'></i>
                                                    </span>
                                                    <span className='cursor-pointer ms-1'>
                                                        <i className='bi bi-dash-circle-fill'></i>
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
export default NodeApiConfig;
